import React, { useState, useEffect, useRef } from "react";
import Header from "./Header.js";
import Footer from "./Footer.js";
import Select from "react-select";
import "bootstrap-icons/font/bootstrap-icons.css";
import { TailSpin } from "react-loader-spinner";
import "./Style.css";
import Select2 from "../../Components/Common/Select2";
import 'select2/dist/css/select2.css';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../Api/apiUrls";
import { getAdminEvents } from "../../Api/apiUrls";
import $ from 'jquery';
import AddEvents from "../../Components/Admin_components/addEvents.js";
import DeleteEvents from "../../Components/Admin_components/deleteEvents.js";
import UpdateEvents from "../../Components/Admin_components/updateEvents.js";
import EventAddMedia from "../../Components/Admin_components/event_addMedia.js";

function Events() {
    const [modalAddEventIsOpen, setAddEventModalIsOpen] =
        useState("");
    const [modalDeleteEventsIsOpen, setDeleteEventsIsOpen] = useState(false);
    const [modalUpdateEventsIsOpen, setUpdateEventsModalIsOpen] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [selectedEventId, setSelectedEventId] = useState(null);
    const [selectedeventStatus, setSelectedEventStatus] = useState("");
    const [SelectedeventType, setSelectedEventType] = useState("");
    const [SelectedeventTitle, setSelectedEventTitle] = useState("");
    const [SelectedeventDescription, setSelectedEventDescription] = useState("");
    const [SelectedeventKeywords, setSelectedEventKeywords] = useState("");
    const [SelectedeventSummary, setSelectedEventSummary] = useState("");
    const [SelectedeventOrganizer, setSelectedEventOrganizer] = useState("");
    const [SelectedeventOrganizerBio, setSelectedEventOrganizerBio] = useState("");
    const [SelectedeventOrganizerLogo, setSelectedEventOrganizerLogo] = useState("");
    const [SelectedeventCity, setSelectedEventCity] = useState("");
    const [SelectedeventDate, setSelectedEventDate] = useState("");
    const [SelectedeventInstructor, setSelectedEventInstructor] = useState("");

    const [hoveredInstructorMoreEventId, setHoveredInstructorMoreEventId] = useState(null);

    const [modalAddEventmediaIsOpen, setAddEventMediaModalIsOpen] = useState("");
    const openAddEventmedia = (eventId) => {
        setSelectedEventId(eventId);
        closeAddEventmedia();
        setAddEventMediaModalIsOpen(true);
    };

    const closeAddEventmedia = () => {
        setAddEventMediaModalIsOpen(false);
    };
    const openUpdateEvents = (eventId, eventTitle, eventDescription, eventKeywords, eventSummary,
        eventOrganizer,
        eventOrganizerBio,
        eventOrganizerLogo,
        eventCity,
        eventDate,
        eventInstructor,
        eventType,
        eventStatus

    ) => {
        setSelectedEventId(eventId);
        setSelectedEventTitle(eventTitle);
        setSelectedEventDescription(eventDescription);
        setSelectedEventKeywords(eventKeywords);
        setSelectedEventSummary(eventSummary);
        setSelectedEventOrganizer(eventOrganizer);
        setSelectedEventOrganizerBio(eventOrganizerBio);
        setSelectedEventOrganizerLogo(eventOrganizerLogo);
        setSelectedEventCity(eventCity);
        setSelectedEventDate(eventDate);
        setSelectedEventInstructor(eventInstructor);
        setSelectedEventType(eventType);
        setSelectedEventStatus(eventStatus);
        closeUpdateEvents();
        setUpdateEventsModalIsOpen(true);
    };
    const closeUpdateEvents = () => {
        setUpdateEventsModalIsOpen(false);
    };

    const openAddEvent = () => {
        closeAddEvent();
        setAddEventModalIsOpen(true);
    };
    const closeAddEvent = () => {
        setAddEventModalIsOpen(false);
    };

    const openDeleteEvents = (eventId) => {
        closeDeleteEevents();
        setSelectedEventId(eventId);
        setDeleteEventsIsOpen(true);
    };

    const closeDeleteEevents = () => {
        setDeleteEventsIsOpen(null);
    };

    const [events, setEvents] = useState(false);

    const refetchEvents = () => {
        fetch(getAdminEvents)
            .then((response) => {
                if (!response.ok) throw new Error("Network response was not ok");
                return response.json();
            })
            .then((data) => {
                setEvents(data.data.Events || []);
            })
            .catch((error) => console.error("Error fetching data:", error));
    };

    useEffect(() => {
        fetch(getAdminEvents)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                const events = data.data.Events;
                setEvents(events);

            })
            .catch((error) => console.error("Error fetching data:", error))
            .finally(() => {
                setIsLoading(false);
            });
    }, []);


    const [searchQuery, setSearchQuery] = useState("");

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const filteredEvents = Array.isArray(events)
        ? events.filter((events) => {
            const values = Object.values(events).map((value) =>
                typeof value === "string" ? value.toLowerCase() : ""
            );
            const isSearchMatch = values.some((value) =>
                value.includes(searchQuery.toLowerCase())
            );
            return isSearchMatch;
        })
        : [];

    const formatCreatedAt = (createdAt) => {
        const createdAtDate = new Date(createdAt);

        // Format the date part
        const datePart = createdAtDate.toLocaleDateString("en-GB", {
            day: "numeric",
            month: "short",
            year: "numeric",
        });

        // Format the time part
        const timePart = createdAtDate.toLocaleTimeString("en-GB", {
            hour: "numeric",
            minute: "numeric",

            hour12: true,
        });

        return `${datePart}`;
    };
    return (
        <div>
            <ToastContainer position="top-right" autoClose={3000} />
            <Header></Header>
            {modalAddEventIsOpen && (
                <AddEvents onClose={closeAddEvent} onSuccess={refetchEvents} />
            )}
            {modalDeleteEventsIsOpen && (
                <DeleteEvents
                    eventId={selectedEventId}
                    onClose={closeDeleteEevents}
                />
            )}
            {modalUpdateEventsIsOpen && (
                <UpdateEvents
                    eventId={selectedEventId}
                    eventTitle={SelectedeventTitle}
                    eventDescription={SelectedeventDescription}
                    eventKeywords={SelectedeventKeywords}
                    eventSummary={SelectedeventSummary}
                    eventOrganizer={SelectedeventOrganizer}
                    eventOrganizerBio={SelectedeventOrganizerBio}
                    eventOrganizerLogo={SelectedeventOrganizerLogo}
                    eventCity={SelectedeventCity}
                    eventDate={SelectedeventDate}
                    eventInstructor={SelectedeventInstructor}
                    eventType={SelectedeventType}
                    eventStatus={selectedeventStatus}
                    onClose={closeUpdateEvents}
                    onSuccess={refetchEvents}
                />
            )}

            {modalAddEventmediaIsOpen && (
                <EventAddMedia onClose={closeAddEventmedia} eventId={selectedEventId} />
            )}
            <main id="main" class="main">
                <div class="pagetitle">
                    <h1>Events</h1>
                </div>
                <section class="section">
                    <div class="card p-2">
                        <div class="parent col-md-12 row mt-2">
                            <div class="col-md-6">
                                <div class="child">
                                    <input
                                        onChange={handleSearchChange}
                                        value={searchQuery}
                                        id="myInput"
                                        type="text"
                                        style={{
                                            borderRadius: "5px",
                                            height: "35px",
                                            padding: "10px",
                                            border: "1px solid lightgrey ",
                                        }}
                                        placeholder="Search..."
                                    />
                                </div>
                            </div>

                            <div class="col-md-6" style={{ textAlign: "right" }}>
                                <div class="child">
                                    <a>
                                        {" "}
                                        <button
                                            id="btnNewUser"
                                            type="button"
                                            data-toggle="modal"
                                            data-target="#modalAdd"
                                            class=" btn-round"
                                            onClick={openAddEvent}
                                        >
                                            <i class="bi bi-person-add"></i> Add Event
                                        </button>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div
                            style={{ marginTop: "50px", display: "flex", marginLeft: "50%" }}>
                        </div>
                        <div class="table-responsive">
                            {isLoading === true ? (
                                <div
                                    style={{
                                        marginTop: "50px",
                                        display: "flex",
                                        marginLeft: "50%",
                                    }}
                                >
                                    <TailSpin color="black" width={50} />
                                </div>
                            ) : events.length > 0 ? (
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th scope="col">Sr.No</th>
                                            <th scope="col">Organizer Logo</th>
                                            <th scope="col">Title</th>
                                            <th scope="col">Organizer</th>
                                            <th scope="col">City</th>
                                            <th scope="col">Instructor Details</th>
                                            <th scope="col">Keywords</th>
                                            <th scope="col">Visit</th>
                                            <th scope="col">Media Count</th>
                                            <th scope="col">Workshop Date</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Created On</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody id="tableBody">
                                        {filteredEvents.map((events, index) => (
                                            <tr key={events.id}>
                                                <th scope="row">{index + 1}</th>
                                                <td>{<img
                                                    src={`https://artiquity.in${events.organizer_image}`}
                                                    style={{ width: "100px", height: "100px" }}
                                                    alt="Cover"
                                                /> || "---"}</td>
                                                <td>{events.title || "---"}</td>
                                                <td>{events.organizer || "---"}</td>
                                                <td>{events.city || "---"}</td>
                                                <td style={{ position: "relative" }}>
                                                    {(() => {
                                                        const isHeartForArt = events.event_type === "Heart For Art";
                                                        const list = events.heart_for_art_instructor;
                                                        const heartInstructors = Array.isArray(list) && list.length;
                                                        if (isHeartForArt && heartInstructors) {
                                                            const showAll = list.length <= 2;
                                                            const visible = showAll ? list : list.slice(0, 2);
                                                            const remaining = list.length - 2;
                                                            const showMore = !showAll && remaining > 0;
                                                            return (
                                                                <>
                                                                    {visible.map((inst, i) => (
                                                                        <span key={inst.id ?? i} style={{ display: "block", marginBottom: i < visible.length - 1 || showMore ? "0.5rem" : 0 }}>
                                                                            <strong>{i + 1}.</strong> {inst.name || "---"}
                                                                            <br />
                                                                            &nbsp;&nbsp;&nbsp;{inst.mobileNumber || "---"}
                                                                            <br />
                                                                            &nbsp;&nbsp;&nbsp;{inst.email || "---"}
                                                                        </span>
                                                                    ))}
                                                                    {showMore && (
                                                                        <span
                                                                            onMouseEnter={() => setHoveredInstructorMoreEventId(events.id)}
                                                                            onMouseLeave={() => setHoveredInstructorMoreEventId(null)}
                                                                            style={{ cursor: "pointer", textDecoration: "underline", color: "var(--bs-primary, #0d6efd)" }}
                                                                        >
                                                                            +{remaining} more
                                                                            {hoveredInstructorMoreEventId === events.id && (
                                                                                <span
                                                                                    className="instructor-more-tooltip"
                                                                                    style={{
                                                                                        position: "absolute",
                                                                                        left: 0,
                                                                                        top: "100%",
                                                                                        marginTop: "2px",
                                                                                        background: "#fff",
                                                                                        border: "1px solid #dee2e6",
                                                                                        borderRadius: "6px",
                                                                                        padding: "8px 10px",
                                                                                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                                                                        zIndex: 1050,
                                                                                        minWidth: "220px",
                                                                                        fontSize: "13px",
                                                                                    }}
                                                                                >
                                                                                    {list.slice(2).map((inst, i) => (
                                                                                        <span key={inst.id ?? i} style={{ display: "block", marginBottom: i < list.length - 3 ? "6px" : 0 }}>
                                                                                            <strong>{i + 3}.</strong> {inst.name || "---"}
                                                                                            <br />
                                                                                            &nbsp;&nbsp;&nbsp;{inst.mobileNumber || "---"}
                                                                                            <br />
                                                                                            &nbsp;&nbsp;&nbsp;{inst.email || "---"}
                                                                                        </span>
                                                                                    ))}
                                                                                </span>
                                                                            )}
                                                                        </span>
                                                                    )}
                                                                </>
                                                            );
                                                        }
                                                        if (events.instructor) {
                                                            return (
                                                                <>
                                                                    {events.instructor.name || "---"}
                                                                    <br />
                                                                    {events.instructor.mobileNumber || "---"}
                                                                    <br />
                                                                    {events.instructor.email || "---"}
                                                                </>
                                                            );
                                                        }
                                                        return "---";
                                                    })()}
                                                </td>
                                                <td>{events?.keywords || "-"}</td>
                                                <td>{events.visit || "0"}</td>
                                                <td>{events.media_count || "0"}</td>
                                                <td>{formatCreatedAt(events.event_date || "--")}</td>
                                                <td>{events.status || "--"}</td>
                                                <td>{formatCreatedAt(events.created_at)}</td>
                                                <td>
                                                    <div className="social-links mt-2">
                                                        <a
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => {
                                                                const isHeartForArt = events.event_type === "Heart For Art";
                                                                let eventInstructor;
                                                                if (isHeartForArt && Array.isArray(events.heart_for_art_instructor) && events.heart_for_art_instructor.length) {
                                                                    eventInstructor = events.heart_for_art_instructor.map((inst) =>
                                                                        inst && (inst.id != null || inst.value != null)
                                                                            ? { value: inst.id ?? inst.value, label: inst.name ?? inst.label ?? "" }
                                                                            : null
                                                                    ).filter(Boolean);
                                                                } else if (events.instructor && (events.instructor.id != null || events.instructor.value != null)) {
                                                                    eventInstructor = {
                                                                        value: events.instructor.id ?? events.instructor.value,
                                                                        label: events.instructor.name ?? events.instructor.label ?? "",
                                                                    };
                                                                } else {
                                                                    eventInstructor = isHeartForArt ? [] : null;
                                                                }
                                                                openUpdateEvents(
                                                                    events.id,
                                                                    events.title,
                                                                    events.description,
                                                                    events.keywords,
                                                                    events.short_summary,
                                                                    events.organizer,
                                                                    events.bio,
                                                                    events.organizer_image,
                                                                    events.city,
                                                                    events.event_date,
                                                                    eventInstructor,
                                                                    { value: events.event_type, label: events.event_type },
                                                                    { value: events.status, label: events.status }
                                                                );
                                                            }}
                                                        >
                                                            <i class="bi bi-pencil"></i>
                                                        </a>
                                                        &nbsp;&nbsp;
                                                        <a
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => openDeleteEvents(events.id)}
                                                        >
                                                            <i class="bi bi-trash3"></i>
                                                        </a>
                                                        <br />
                                                        <a
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => openAddEventmedia(events.id)}
                                                        >
                                                            <i class="bi bi-camera"></i>
                                                        </a>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>

                                </table>

                            ) : (
                                <h3 style={{ textAlign: "center" }}> No data available </h3>
                            )}


                        </div>
                    </div>
                    <div>
                        {" "}
                        <p
                            style={{
                                backgroundColor: "#000",
                                color: "white",
                                padding: "10px",
                            }}
                        >{filteredEvents.length} Total
                        </p>
                    </div>
                </section>
            </main>
            <Footer></Footer>

        </div>
    )
}

export default Events
